module.exports = __webpack_public_path__ + "img/work01-hover.829486a9.jpg";